import { coreServices } from './coreService';
import store from '../store/store'; 

/* eslint-disable-next-line */
export const trialServices = {
  getTrialInformation(trialId) {
    try {
      const result = coreServices.getTrial(trialId);
      return result;
    } catch (err) {
      return [];
    }
  },
  // User accept store information
  async saveDataRejectedInformation(data, trialId, currentLanguage) {
    try {
      const { patientData } = data;
      const userId = store.state.provisionalUserId;
      // data rejected already saved in saveRejectedTrial
      const result = await coreServices.saveDataRejectedUpdateAcceptedUserTrial(patientData, userId, trialId, currentLanguage);
      return result;
    } catch (err) {
      console.log(`Error saving rejected information: ${err}`);
      return [];
    }
  },
  // New update Jun 2025: user data is saved always after user form view is completed
  async saveUserDataFromFormView(data, trialId) {
    try {
      const { patientData } = data;
      const docId = await coreServices.saveUserDataFromFormView(patientData, trialId);
      store.commit('setProvisionalUserId', docId);
      return docId;
    } catch (err) {
      console.error(`Error saving provisional accepted data: ${err}`);
      return [];
    }
  },
  async saveProvisionalAcceptedData(data) {
    try {
      const { patientData } = data;
      const docId = await coreServices.saveDataUserAcceptedProvisional(patientData);
      store.commit('setProvisionalUserId', docId);
      return docId;
    } catch (err) {
      console.error(`Error saving provisional accepted data: ${err}`);
      return [];
    }
  },
  // New: user is saved always as no accepted provisionaling
  async saveProvisionalRejectedData(data, trialId, currentLanguage) {
    try {
      const { patientData } = data;
      const answers = {};
      for (let i = 0; i < patientData.questions.length; i += 1) {
        const question = patientData.questions[i];
        const answer = patientData.question_answered[i].option;
        answers[question] = answer;
      }
      // save anonimous data even user not accept
      const anonimousData = {
        language: currentLanguage,
        created_at: new Date(),
        trial_id: trialId,
        trial_name: patientData.trial_name,
        answers,
      };

      const anonimousUserData = {
        language: currentLanguage,
        created_at: new Date(),
        trial_id: trialId,
        trial_name: patientData.trial_name,
        email: patientData.email,
        accept: false,
      };

      const docId = await coreServices.saveProvisionalRejectedUserData(anonimousUserData, anonimousData);
      store.commit('setProvisionalUserId', docId);
      return docId;
    } catch (err) {
      console.error(`Error saving rejected information: ${err}`);
      return [];
    }
  },
  saveRejectedTrialInformation(patientData) {
    try {
      let formAnswered = '';
      for (let i = 0; i < patientData.questions.length; i += 1) {
        const question = patientData.questions[i];
        const answer = patientData.question_answered[i].option;
        formAnswered += `${question}:  ${answer}`;
        if (i < patientData.questions.length - 1) {
          formAnswered += ', ';
        }
      }
      const result = coreServices.saveRejectedTrial({
        name: patientData.name,
        surname: patientData.surname,
        email: patientData.email,
        phone: patientData.phone,
        trial_id: patientData.trial_id,
        trial_name: patientData.trial_name,
        created_at: new Date(),
        formAnswered,
      });
      return result;
    } catch (err) {
      return [];
    }
  },
  saveTrialInformation(trialInformation, selectedLanguage) {
    try {
      const userId = store.state.provisionalUserId;
      return coreServices.saveTrial(trialInformation, selectedLanguage, userId);
    } catch (err) {
      return [];
    }
  },
  checkIfEmailExists(email, trialId) {
    try {
      const result = coreServices.checkTrialEmail(email, trialId);
      return result;
    } catch (err) {
      return err;
    }
  },
};
